import { Link, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const Sidebar = ({ collapsed, onToggle, onLogout }) => {
  const { hasPermission, user } = useAuthStore();
  const location = useLocation();

  const menuItems = [
    {
      path: '/dashboard',
      icon: 'dashboard',
      label: 'Dashboard',
      permission: 'canViewReports'
    },
    {
      path: '/servicios',
      icon: 'local_shipping',
      label: 'Servicios',
      permission: 'canManageTrips'
    },
    {
      path: '/calendar',
      icon: 'calendar_month',
      label: 'Calendario',
      permission: 'canManageTrips'
    },
    {
      path: '/drivers',
      icon: 'person',
      label: 'Conductores',
      permission: 'canManageDrivers'
    },
    {
      path: '/vehicles',
      icon: 'directions_car',
      label: 'Vehículos',
      permission: 'canManageVehicles'
    },
    {
      path: '/users',
      icon: 'group',
      label: 'Usuarios',
      permission: 'canManageUsers'
    },
    {
      path: '/tabulador',
      icon: 'payments',
      label: 'Tabulador',
      permission: 'canViewTabulador'
    },
    {
      path: '/reportes',
      icon: 'analytics',
      label: 'Reportes',
      permission: 'canViewReports'
    },
    {
      path: '/pendientes-ike',
      icon: 'pending_actions',
      label: 'Asignación Masiva',
      permission: 'canViewPendientesIKE'
    }
  ];

  const filteredMenu = menuItems.filter(item => hasPermission(item.permission));

  return (
    <aside 
      className={`sb ${collapsed ? 'collapsed' : ''}`}
      style={{ 
        background: '#171717', 
        color: 'white', 
        minHeight: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 30,
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto'
      }}
    >
      {/* Top Section */}
      <div className="sb__top" style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px' }}>
        <button 
          className="sb__burger"
          onClick={onToggle}
          title={collapsed ? "Expandir menú" : "Colapsar menú"}
          style={{ 
            height: '36px', 
            width: '36px', 
            borderRadius: '10px', 
            border: '1px solid rgba(255,255,255,.12)',
            background: 'rgba(255,255,255,.05)', 
            color: '#fff', 
            cursor: 'pointer', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          <span className="material-symbols-outlined">{collapsed ? 'menu' : 'close'}</span>
        </button>
        <div className="sb__brand" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src="/racingmotors.png" alt="Racing Motors" className="sb__logo" style={{ width: '100%', maxHeight: '48px', objectFit: 'contain' }} />
        </div>
      </div>

      {/* Navigation */}
      <nav className="sb__nav" style={{ padding: '8px 8px 0', display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '6px' }}>
        {filteredMenu.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`sb__link ${isActive ? 'is-active' : ''}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: collapsed ? '0' : '12px',
                justifyContent: collapsed ? 'center' : 'flex-start',
                height: '36px',
                padding: '0 10px',
                borderRadius: '8px',
                textDecoration: 'none',
                color: '#eaeaea',
                background: isActive ? 'var(--secondary)' : 'transparent',
                border: '1px solid transparent',
                transition: '.15s',
                fontWeight: '600'
              }}
            >
              <span className="material-symbols-outlined sb__icon" style={{ width: '22px', textAlign: 'center', flexShrink: 0 }}>{item.icon}</span>
              {!collapsed && <span className="sb__label" style={{ fontWeight: '700', whiteSpace: 'nowrap' }}>{item.label}</span>}
            </Link>
          );
        })}
      </nav>

      {/* Bottom Section */}
      <div className="sb__bottom" style={{ marginTop: 'auto', padding: '8px' }}>
        {!collapsed && (
          <div style={{ padding: '8px', color: '#eaeaea', fontSize: '12px', textAlign: 'center' }}>
            <div>{user?.nombre || user?.email}</div>
            <div style={{ opacity: 0.7 }}>
              {user?.role === 'admin' ? 'Administrador' : 
               user?.role === 'despachador' ? 'Despachador' : 
               'Visor de Reportes'}
            </div>
          </div>
        )}
        <button 
          className="sb__link" 
          onClick={onLogout} 
          title="Cerrar Sesión"
          style={{ 
            justifyContent: collapsed ? 'center' : 'flex-start',
            marginTop: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: collapsed ? '0' : '12px',
            height: '36px',
            padding: '0 10px',
            borderRadius: '8px',
            textDecoration: 'none',
            color: '#eaeaea',
            background: 'transparent',
            border: '1px solid transparent',
            transition: '.15s',
            fontWeight: '600',
            cursor: 'pointer',
            width: '100%'
          }}
        >
          <span className="material-symbols-outlined sb__icon" style={{ width: '22px', textAlign: 'center', flexShrink: 0 }}>logout</span>
          {!collapsed && <span className="sb__label" style={{ fontWeight: '700', whiteSpace: 'nowrap' }}>Cerrar Sesión</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;